/*
 * @Description: 登录API
 */
import request from '@/utils/request';
import router from '@/router/index'

export async function login(params: any) {
    return request.post(`/login`, params)
}



// 刷新token
export async function refresh() {
    //@ts-ignore
    let refreshToken = localStorage.getItem('refreshToken') || ''
    if (!refreshToken) {
        router.push('/login')
        return
    }
    return request.get(`/refresh/${refreshToken}`, {})
}

/** 用户注册 */
export async function register(params: any) {
    return request.post(`/register`, params)
}
/** 获取用户信息 */
export async function userInfo() {
    return request.get(`/userInfo`)
}
/** 修改用户信息 */
export async function updateUserInfo(params: any) {
    return request.post(`/updateUserInfo`, params)
}
/** 修改密码 */
export async function updatePassword(params: any) {
    return request.post(`/updatePassword`, params)
}
/** 图片上传 */
export async function fileUpload(params: any) {
    return request.post(`/file/upload`, params)
}
/** 删除文件 */
export async function fileDelete(params: any) {
    return request.post(`/file/delete`, params)
}

